import { useState } from "react";
import { Box, InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useNotification } from "@hooks/useNotifications";
import { validationTemplatesService } from "features/languages/services/validation-templates-services";
import type { ValidationTemplates } from "features/languages/types/validation-templates";

const DEFAULT_ITEM_LABEL = "-- Default template --";
const defaultValidationTemplate = {
  id: DEFAULT_ITEM_LABEL,
  name: DEFAULT_ITEM_LABEL,
};

export const SelectValidationTemplate = ({
  projectLanguageId,
  validationTemplateId,
  validationTemplates,
}: {
  projectLanguageId: number;
  validationTemplateId: number;
  validationTemplates: ValidationTemplates;
}) => {
  const { showError, showSuccess } = useNotification();
  const [template, setTemplate] = useState(() => {
    const id = validationTemplateId?.toString();
    return id || DEFAULT_ITEM_LABEL;
  });
  const validationTemplatesUI = [defaultValidationTemplate, ...validationTemplates];

  const handleChange = async (event: SelectChangeEvent) => {
    try {
      let id;

      if (event.target.value === DEFAULT_ITEM_LABEL) {
        id = null;
      } else {
        id = Number(event.target.value);
      }

      await validationTemplatesService.assignValidationTemplate({
        projectLanguageId,
        validationTemplateId: id,
      });
      showSuccess("Validation template assigned successfully");
    } catch (error) {
      showError("Failed to assign validation template");

      console.error(error);
    }
    setTemplate(event.target.value as string);
  };

  return (
    <Box sx={{ width: 300 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Template</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={template}
          label="Template"
          onChange={handleChange}
        >
          {validationTemplatesUI.map(({ id, name }) => (
            <MenuItem value={id?.toString()} key={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
